import React from 'react';
import { bonuses } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="bonos-titulo" data-id="element-1" data-mp="gxgcjp5l2bdi">
      <div className="mx-auto max-w-4xl" data-id="element-2" data-mp="vqtbwwu2fpyu">
        <SectionHeading id="bonos-titulo" title={<>
              5 Bonos Estratégicos <Accent data-id="element-4" data-mp="14ssu3sgth03d">Siempre Incluidos</Accent>
            </>} subtitle="Siempre incluidos, siempre gratis: implementación, clases listas, terminología, checklists y casos reales." data-id="element-3" data-mp="qt9y1y1a5f7f" />

        <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-5" data-mp="1eich9abkbg41">
          {bonuses.map(({
          number,
          title,
          description,
          image
        }) => <li key={number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-6" data-mp="19l2q9q8iywe3">
              <div className="relative overflow-hidden rounded-xl" data-id="element-7" data-mp="1jjryssej74ho">
                <img src={image} alt={`Portada del bono ${number}: ${title}`} className="aspect-[4/3] w-full object-cover" data-id="element-8" data-mp="3pqtuuntyc3gf" />
                <span className="absolute left-3 top-3 rounded-md bg-ember-500 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-white" data-id="element-9" data-mp="2lvy2xcdyxtw">
                  Bono {number}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-forest-700 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-ember-400" data-id="element-10" data-mp="ckbkwo4drkxl">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-forest-800" data-id="element-11" data-mp="ldew0prjzlp2">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/70" data-id="element-12" data-mp="qaoron5jctlc">{description}</p>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-2xl bg-forest-700 p-8 text-center" data-id="element-13" data-mp="v8gkrkhx2lr4">
            <p className="font-display text-2xl font-semibold leading-snug text-cream-50" data-id="element-14" data-mp="akz7k4tgj8mv">
              Valor total de bonos <span className="text-ember-400" data-id="element-15" data-mp="5mnw5pnikq2j">$70 USD</span>
            </p>
            <p className="mt-3 text-sm text-cream-100/75" data-id="element-16" data-mp="kb1zs2sr8ik5">GRATIS con tu Kit.</p>
          </li>
        </ul>
      </div>
    </section>;
}